import { Checkbox } from '@mantine/core';
import { NetworkType } from '@zorro/clients';
import { UnderlineTooltip } from '@zorro/design-system/v2/Tooltip';
import { Flex, Grid } from '@zorro/web/design-system';

import classNames from './PlanFilter.module.scss';

export const NETWORK_TYPE_FILTER_VALUES = [
  NetworkType.HMO,
  NetworkType.PPO,
  NetworkType.EPO,
  NetworkType.POS,
];

export const planTypeTooltipConfig: Record<string, string> = {
  EPO: `A health plan that typically covers only in-network care,
        except in emergencies. EPOs usually don't require referrals
        to see specialists and often have more extended networks
        compared to some other plan types`,
  POS: `POS (Point of Service): A plan that provides coverage for both
        in-network and out-of-network healthcare services.`,
  HMO: `Health Maintenance Organization: A health plan that
        typically covers only in-network care, except in
        emergencies.`,
  PPO: `Preferred Provider Organization: A health plan where you
        get more coverage using in-network providers but still
        receive partial coverage outside the network.`,
};

export const NetworkFilters = ({
  filterOptions,
  selectedFilters,
}: {
  filterOptions: Set<NetworkType> | undefined;
  selectedFilters: string[];
}) => {
  if (!filterOptions) {
    return null;
  }
  return (
    <Grid columns={4} gap="sm">
      {NETWORK_TYPE_FILTER_VALUES.map((filter) => {
        if (filterOptions.has(filter)) {
          return (
            <Grid.Col key={filter} span={1}>
              <Checkbox.Card
                checked={selectedFilters?.includes(filter)}
                value={filter}
                className={classNames.checkboxCard}
              >
                <Flex p="md" align="center" gap="xs" h="3rem" justify="center">
                  <UnderlineTooltip label={planTypeTooltipConfig[filter]}>
                    {filter}
                  </UnderlineTooltip>
                </Flex>
              </Checkbox.Card>
            </Grid.Col>
          );
        }
        return null;
      })}
    </Grid>
  );
};
